import React, { ComponentProps, FunctionComponent } from "react";

const ProtectedDataIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 10 10",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M3.253 7.863c-1.179 0-2.484-.2-3.253-.695v1.368c0 .611 1.453 1.095 3.253 1.095.748 0 1.432-.084 1.98-.232a5.294 5.294 0 0 1-.97-1.6 8.101 8.101 0 0 1-1.01.064ZM3.253 5.38C2.074 5.38.769 5.18 0 4.695v1.369c0 .61 1.453 1.094 3.253 1.094.274 0 .537-.01.79-.031a5.43 5.43 0 0 1-.17-1.316v-.453c-.199.01-.41.022-.62.022ZM4.895 3.915a2.209 2.209 0 0 0 1.38-.631l.136-.137.084-.085V2.2c-.768.495-2.063.695-3.242.695-1.179 0-2.484-.2-3.253-.695v1.369c0 .61 1.453 1.094 3.253 1.094.242 0 .463-.01.695-.031a1.15 1.15 0 0 1 .947-.716ZM6.505 1.095c0 .604-1.456 1.095-3.252 1.095C1.456 2.19 0 1.7 0 1.095S1.456 0 3.253 0c1.796 0 3.252.49 3.252 1.095ZM9.443 4.62a2.858 2.858 0 0 1-1.821-.842l-.137-.137a.407.407 0 0 0-.569 0l-.137.137a2.91 2.91 0 0 1-1.82.842.401.401 0 0 0-.37.4v.79c0 1.716.927 3.295 2.422 4.137a.435.435 0 0 0 .2.053.433.433 0 0 0 .2-.053A4.748 4.748 0 0 0 9.83 5.81v-.79c-.02-.21-.178-.389-.388-.4ZM8.306 6.347 7.169 7.484a.367.367 0 0 1-.253.105.387.387 0 0 1-.252-.105l-.579-.579a.35.35 0 1 1 .495-.495l.336.337.895-.895a.35.35 0 1 1 .495.495Z",
      fill: "currentColor",
    })
  );
};

const ForwardRef = React.forwardRef(ProtectedDataIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
